import { Container, Typography } from '@mui/material';

export default function ErrorPage() {
  return (
    <Container>
      <Typography variant="h2">Ups!</Typography>
      <Typography variant="subtitle1">
        Tato stránka nebyla nalezena :(
      </Typography>
    </Container>
  );
}
